module.exports = __webpack_public_path__ + "img/icon.82cd089c.png";